import React from "react";
import { Users, Building2, Globe, Award } from "lucide-react";
import "../Components/AboutSection.css"
import NavBar from "../Components/NavBar";
import Footer from "../Components/Footer";
import VisionMission from "../Components/VisionMission";

const stats = [
    { icon: <Building2 size={32} />, value: "$3B+", label: "Transactions Arranged" },
    { icon: <Users size={32} />, value: "17+", label: "Years of Excellence" },
    { icon: <Globe size={32} />, value: "24+", label: "African Countries" },
    // { icon: <Award size={32} />, value: "100%", label: "Success Rate" },
];

function AboutPage() {
    return ( 
        <section id="about" >
            <NavBar />
            <div className="about-section py-5">


                <div className="container">
                    {/* Header */}
                    <div className="text-center mb-5 about-header">
                        <h2 className="fw-bold11 display-5">
                            About <span className="the-color">Benchmark Solutions</span>
                        </h2>
                        <p className="lead text-muted mt-3">
                            Since 2007, Benchmark Solutions Limited has been at the forefront of arranging
                            specialized financial solutions for businesses and governments across Africa. Based
                            in Nairobi, Kenya, we leverage our deep understanding of African markets to connect
                            opportunities with capital.
                        </p>
                    </div>

                    {/* Stats Grid */}
                    <div className="row text-center g-4 mb-5 row25">
                        {stats.map((stat, index) => (
                            <div key={index} className="col-12 col-sm-6 col-lg-3">
                                <div className="about-card p-4">
                                    <div className="stat-icon mx-auto mb-3">{stat.icon}</div>
                                    <h3 className="stat-value fw-bold mb-1">{stat.value}</h3>
                                    <p className="stat-label mb-0">{stat.label}</p>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Journey */}
                    <div className="about-journey p-5 rounded-4 text-white">
                        <br />
                        <h3 className="fw-bold22 mb-3">Our Journey</h3>
                        <p className="fs-5 mb-3 text-white">
                            What began as a vision to bridge the gap between African businesses and global capital
                            has evolved into a trusted partnership spanning multiple countries and sectors. Our success
                            is measured not just in the value of transactions we arrange, but in the lasting impact
                            on communities and economies.
                        </p>
                        <p className="fs-5">
                            We bring together deep local knowledge, international best practices, and an unwavering
                            commitment to excellence, making us the preferred partner for businesses seeking to scale
                            and governments looking to drive economic transformation.
                        </p>
                    </div>
                </div>
            </div>
            <VisionMission />

            <Footer />
        </section>
    );
};

export default AboutPage